import * as yup from 'yup';

export const DAY_LABELS = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const MIN_TAT    = 25;
export const LABEL_W    = 148;
export const DEF_ROW_H  = 58;
export const RULER_H    = 50;
export const RULER_TOP  = 22;
export const DAY_W_BASE = 210;
export const MIN_ZOOM   = 0.3;
export const MAX_ZOOM   = 4;

export const AC_COLORS = [
  '#1976d2', '#388e3c', '#f57c00', '#7b1fa2', '#c62828',
  '#00838f', '#558b2f', '#ad1457', '#283593', '#4e342e',
];

const WIDEBODY = [/74/, /77/, /78/, /76/, /330/, /350/, /380/, /340/];
export const isWideBody = (t = '') => WIDEBODY.some((p) => p.test(t.toUpperCase()));

export const toMin = (hhmm = '') => {
  const [h, m] = (hhmm || '00:00').split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const toHHMM = (min) => {
  const m = ((min % 1440) + 1440) % 1440;
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
};

export const rotationSchema = yup.object({
  seasonId:     yup.string().required('Season is required'),
  rotationCode: yup.string().required('Rotation code is required'),
  acType:       yup.string().required('AC type is required'),
  acReg:        yup.string(),
  notes:        yup.string(),
});
